/*
 Akhila 04/07/2023 2699762545 Added delete functionality and delete reason dialog box
 Sohel 04/08/2023 2699762545 Fixed Toast Message Reset Issue
 Ravi 04/14/2023 2699762545 changed form from formik to useForm
 Akhila 04/14/2023 2699762545 bug fixed id issue
 Prakash 19-04-2023 2698964415 remove whitespace

*/
import React, {useContext, useEffect, useState, useCallback} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {TextField, Button, FormHelperText} from '@material-ui/core';
import {useForm} from 'react-hook-form';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {resetRequestLetters, deleteLetterRequested} from '../../../redux/reducers/LetterHistory';
import PageLoader from '../../../components/PageLoader';
import {useDispatch, useSelector} from 'react-redux';
import debounce from 'lodash.debounce';
import Filter from 'bad-words';
import {profinityWords} from '../../../util/ProfinityWord';
import {useUpdateEffect} from 'react-use';

const LetterDeleteRequest = ({deleteData, setIsDelete, isDelete, tableRef}) => {
  const {labelColor} = useContext(ThemeContext);
  const useStyles = makeStyles((theme) => ({
    labelName: {
      '& .MuiOutlinedInput-input': {
        // padding: '11.3px 7px',
        fontSize: '12px !important',
        color: `${labelColor} !important`,
        paddingLeft: '0 !important',
      },
    },
    inputLabel: {
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        fontWeight: '600',
      },
    },

    detailsText: {
      fontSize: '0.8rem',
      fontWeight: '500',
      backgroundColor: '#FFF',
      padding: 10,
      boxShadow:
        '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    },
    specialNeeds: {
      'position': 'relative',
      'display': 'flex',
      'justifyContent': 'flex-end',
      'margin': '0 10px 10px 10px !important',
      'padding': '0px 10px 5px',
      '& .MuiFormControl-marginDense': {
        marginTop: '0.5em !important',
        marginBottom: '0.25em !important',
      },
    },
    sidepanelSpecialNeeds: {
      'position': 'relative',
      'display': 'flex',
      'justifyContent': 'flex-end',
      // margin: "10px !important",
      'padding': '15px 10px 5px 10px',
      '&  .MuiFormControl-marginDense': {
        marginTop: '8px !important',
        marginBottom: '4px !important',
      },
    },
    micButton: {
      position: 'absolute',
      top: -20,
      right: '40px',
      alignItems: 'flex-start',

      minWidth: '30px !important',
      zIndex: 1,
      color: 'red',
    },
    stopButton: {
      position: 'absolute',
      top: -20,
      alignItems: 'flex-start',
      minWidth: '30px !important',
      zIndex: 1,
      color: 'blue',
    },
    buttonRoot: {
      'lineHeight': 1.75,
      [theme.breakpoints.down('md')]: {
        lineHeight: 1.5,
        padding: '6px 15px',
      },
      '& .MuiButton-label': {
        fontSize: '0.813rem',
        [theme.breakpoints.down('md')]: {
          fontSize: '0.688rem',
          letterSpacing: 1,
        },
      },
    },
    cancelIcon: {
      bottom: '243px',
      color: 'red',
      minWidth: '50px',
    },
    stopIcon: {
      bottom: '243px',
      color: 'blue',
      minWidth: '50px',
    },
    notesError: {
      '& .MuiFormHelperText-root': {
        bottom: '-10px !important',
        left: '10px !important',
        position: 'absolute',
      },
    },
    sidepanelMicButtonRight: {
      right: '214px',
    },
    sidepanelstopButtonRight: {
      right: '185px',
    },
    helperTxt: {
      color: 'blue',
      position: 'absolute',
      top: '205px',
      left: '10px',
    },
    sidepanelHelperTxt: {
      color: 'blue',
    },
  }));

  const classes = useStyles();
  const dispatch = useDispatch();
  const {requestLettersStatus, successMsg, isLoading, errorMsg} = useSelector(
    ({letterHistory}) => letterHistory,
  );
  const initialValues = {
    addaNote: '',
  };
  const {register, handleSubmit, errors, reset} = useForm({
    defaultValues: initialValues,
  });
  const [validateNotes, setValidateNotes] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [notes, setNotes] = useState('');
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  useEffect(() => {
    reset(initialValues);
    if (requestLettersStatus === 200) {
      setCharLimitMsg(false);
      setValidateNotes(false);
      setNotes('');
    }
  }, [requestLettersStatus]);

  useUpdateEffect(() => {
    if (cancel && notes?.length === 0) {
      setValidateNotes(false);
      setCancel(false);
    } else if (notes?.length === 0) {
      // setValidateNotes(true);
      // setCancel(false);
    } else {
      setValidateNotes(false);
    }
  }, [notes?.length]);
  // const validationSchema = Yup.object().shape({
  //   addaNote: Yup.string().required("Letter Request delete reason is required."),
  // });
  const debouncedSave = useCallback(
    debounce(
      (nextValue) =>
        nextValue.length <= 4 ?
          handleSetNotes(nextValue) : // : nextValue.length > 1
          setNotes(filter.clean(nextValue)),
      // : setNotes(nextValue),
      2000,
    ),
    [],
  );
  const filter = new Filter({placeHolder: '*'});
  filter.addWords(...profinityWords);
  const handleFilter = (value) => {
    setCharLimitMsg(true);
    const nextValue = value;
    setNotes(nextValue);
    nextValue && debouncedSave(nextValue);
  };
  const handleClose = () => {
    setValidateNotes(false);
    setCancel(true);
    setNotes('');
  };
  const handleSetNotes = (value) => {
    for (const i in profinityWords) {
      if (value === profinityWords[i] && value.length > 1) {
        const replacedWord =
          value.length === 2 ?
            value.replace(value, '**') :
            value.length === 3 ?
              value.replace(value, '***') :
              value.replace(value, '****');
        setNotes(replacedWord);
        break;
      }
    }
  };

  useEffect(() => {
    if ((requestLettersStatus === 200 && successMsg) || errorMsg) {
      setTimeout(() => {
        dispatch(resetRequestLetters());
      }, 1500);
      setIsDelete(false);
      tableRef.current.onQueryChange();
    }
  }, [requestLettersStatus, successMsg]);

  const onSubmit = (values) => {
    !notes && setValidateNotes(true);

    const deleteId = deleteData.map((id) => {
      return id?.letterRequestId;
    });
    const payload = {
      letterRequestIds: deleteId || [],
      deleteReason: values?.addaNote,
    };
    if (values?.addaNote) {
      dispatch(deleteLetterRequested(payload));
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={`${classes.specialNeeds} ${classes.notesError} new-standard-textfields`}>
          <TextField
            multiline={true}
            minRows={4}
            maxRows={10}
            margin="dense"
            variant="outlined"
            className={` ${classes.labelName} ${classes.inputLabel}`}
            placeholder={`Enter Delete Reason`}
            spellCheck="true"
            // disabled={play}
            // defaultValue={initialValues.addaNote0}
            value={notes}
            error={validateNotes || notes?.length > 500}
            onChange={(e, value) => handleFilter(e.target.value)}
            // inputRef={register}
            name="addaNote"
            inputRef={register({
              maxLength: {
                value: 500,
                message: 'Cannot exceed 500 characters',
              },
            })}
            inputProps={{
              spellCheck: true,
              lang: 'en',
              maxLength: 500,
            }}
            // touched={touched}
            errors={errors}
            fullWidth={true}
          />
          {!errors?.addaNote && notes?.length > 0 && notes?.length < 500 && charLimitMsg ? (
            <div className="validation-text">
              <FormHelperText variant="outlined">
                Allows {500 - notes?.length} Characters Only.
              </FormHelperText>
            </div>
          ) : null}
          {notes?.length > 0 && notes?.length > 500 ? (
            <FormHelperText className="ml-3">
              Letter request delete reason cannot exceed 500 characters
            </FormHelperText>
          ) : null}
          {validateNotes ? (
            <FormHelperText
              className="ml-3"
              style={{
                color: 'red',
              }}
            >
              Letter Request delete reason is required.
            </FormHelperText>
          ) : null}
        </div>
        <div className="d-flex justify-content-center new-standard-textfields">
          <Button
            variant="outlined"
            className={`reset-btn mr-1 ${classes.buttonRoot}`}
            onClick={() => handleClose()}
          >
            Reset
          </Button>
          <Button
            type="submit"
            variant="outlined"
            className={`search-btn ml-1 ${classes.buttonRoot}`}
          >
            Save
          </Button>
        </div>
      </form>
      {isLoading && <PageLoader />}
    </>
  );
};

export default LetterDeleteRequest;
